module.exports = __webpack_public_path__ + "static/media/index.fbae9c5a.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/dispute-log/index.scss
// module id = 733
// module chunks = 0